import type { SnapshotFrom } from 'xstate';
import { feature, useFeature } from '@/app/context';
import { stopSelectionMachine } from './stop-selection.machine';

export const useStopSelectionRef = () => feature('stop-selection');
export const useStopSelection = <R>(selector: (snapshot: SnapshotFrom<typeof stopSelectionMachine>) => R) =>
  useFeature('stop-selection', selector);
export const useStopSelectionActions = () => {
  const ref = useStopSelectionRef();
  return {
    loadView: () => ref.send({ type: 'stop-selection.load-view' }),
    chooseRoute: (scheduleId: string, routeId: string) =>
      ref.send({ type: 'stop-selection.choose-route', scheduleId, routeId }),
    chooseDirection: (stopSelectionId: string, directionId: string) =>
      ref.send({ type: 'stop-selection.choose-direction', stopSelectionId, directionId }),
    chooseStop: (stopSelectionId: string, stopId: string) =>
      ref.send({ type: 'stop-selection.choose-stop', stopSelectionId, stopId }),
    refresh: (stopSelectionId: string) => ref.send({ type: 'stop-selection.refresh', stopSelectionId }),
  };
};
